module.exports = __webpack_public_path__ + "components/page-footer/static/meteo365__logo--white-b0550bc06c9641a4dffa2552a361d507.png";